import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarningYellow = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M126.47 972.795h771.071c78.848 0 128-85.504 88.576-153.6l-385.536-666.11c-39.424-68.096-137.727-68.096-177.151 0l-385.536 666.11c-39.424 68.096 9.728 153.6 88.576 153.6zM512.005 614.395c-28.159 0-51.199-23.040-51.199-51.198v-102.4c0-28.16 23.040-51.2 51.199-51.2s51.2 23.040 51.2 51.2v102.4c0 28.158-23.040 51.198-51.2 51.198zM563.205 819.195h-102.399v-102.4h102.399v102.4z",
		fill: "rgb(242, 201, 76)"
	})
});
const ForwardRef = forwardRef(SvgWarningYellow);
export default ForwardRef;
